// extracted by css-extract-rspack-plugin
export default {"body":"body-i2Ov8I","button":"button-fzdsRT","lead":"lead-aruUyo","pic":"pic-K0Ulu3"};